export default {
  // getAllApplications
  START_GET_APP_LIST: "START_GET_APP_LIST",
  GET_APP_LIST_SUCCESS: "GET_APP_LIST_SUCCESS",
  GET_APP_LIST_FAILED: "GET_APP_LIST_FAILED",
  // getApplicationById
  START_GET_APP_BY_ID: "START_GET_APP_BY_ID",
  GET_APP_BY_ID_SUCCESS: "GET_APP_BY_ID_SUCCESS",
  GET_APP_BY_ID_FAILED: "GET_APP_BY_ID_FAILED",
  // updateClientSecret
  START_UPDATE_CLIENT_SECRET: "START_UPDATE_CLIENT_SECRET",
  UPDATE_CLIENT_SECRET_SUCCESS: "UPDATE_CLIENT_SECRET_SUCCESS",
  UPDATE_CLIENT_SECRET_FAILED: "UPDATE_CLIENT_SECRET_FAILED",
  // generateClientCertificate
  START_GENERATE_CLIENT_CERTIFICATE: "START_GENERATE_CLIENT_CERTIFICATE",
  GENERATE_CLIENT_CERTIFICATE_SUCCESS: "GENERATE_CLIENT_CERTIFICATE_SUCCESS",
  GENERATE_CLIENT_CERTIFICATE_FAILED: "GENERATE_CLIENT_CERTIFICATE_FAILED",
  // startSyncApplictionsJob
  START_APP_SYNC_JOB: "START_APP_SYNC_JOB",
  START_APP_SYNC_JOB_SUCCESS: "START_APP_SYNC_JOB_SUCCESS",
  START_APP_SYNC_JOB_FAILED: "START_APP_SYNC_JOB_FAILED",
}